<div class="d-flex flex-column w-100">
    <div class="d-flex w-100 gradient" [style]="gradientCSS"></div>
    <div class="d-flex w-100 justify-content-between">
        <span>{{ minimumValueText() }}</span>
        <span>{{ maximumValueText() }}</span>
    </div>
    <div style="text-align: center">
        <span class="max-value">{{ label() }}</span>
    </div>
</div>
